import { MarketplaceChannelLogListPage } from "@/features/marketplace-channel-log/pages/MarketplaceChannelLogListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/marketplace-channel-log/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["marketplace_channel_api_logs.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: MarketplaceChannelLogListPage,
});
